import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { FaCog } from "react-icons/fa";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { getFinStats, getUserDashboardWidget } from "http/UAM/userDashboardWidget.helper";
import { Link } from "react-router-dom";
import StatsCard from "../../components/StatsCard";
import DealsCreated from "components/DealsCreated";
import FinAssigned from "components/FinAssigned";
import { decryptedValue, isPermission } from "common/utility";
import DealStatusFin from "../../components/CommonForBoth/DealStatusFin";
import MonthlyDealsCreated from "components/Common/MonthwiseDealFinancier";

const FinancersDashboard = () => {
  document.title = "Dashboard | FundLync";
  const [role, setRole] = useState(null);
  const [finStatsData, setFinStatsData] = useState([]);
  const [permissions, setPermissions] = useState({
    financier_stats: 1,
    monthwise_deal_interst: 1,
    deal_assigned_to_FI_users: 1,
    deal_status: 1
  });

  const user = decryptedValue(localStorage.getItem("user"));
  
  useEffect(() => {
    getUserDashboardWidget({ userId: user.id })
      .then((response) => {
        if (response.status) {
          checkUserDashboardWidgets(response.data?.rows[0]?.dashboardWidgets);
        } else {
          checkPermissions();
        }
      })
      .catch((error) => {
        console.error(error);
      });
    getFinStats()
      .then((res) => setFinStatsData(res.data))
      .catch((err) => console.error(err, "err"));
    if (user) {
      setTimeout(() => {
        setRole(user.roleName);
      }, 100);
    }
  }, []);

  const checkUserDashboardWidgets = (userDashboardWidgetList) => {
    const financier_stats = userDashboardWidgetList.financier_stats === 1;
    const deal_status = userDashboardWidgetList.deal_status === 1;
    const monthwise_deal_interst = userDashboardWidgetList.monthwise_deal_interst === 1;
    const deal_assigned_to_FI_users = userDashboardWidgetList.deal_assigned_to_FI_users === 1;
    setPermissions({
      financier_stats,
      monthwise_deal_interst,
      deal_assigned_to_FI_users,
      deal_status
    });
  };

  const checkPermissions = async () => {
    const financier_stats = await isPermission("financier_stats", "view_permission");
    const deal_status = await isPermission("deal_status", "view_permission");
    const monthwise_deal_interst = await isPermission("monthwise_deal_interst", "view_permission");
    const deal_assigned_to_FI_users = await isPermission("deal_assigned_to_FI_users", "view_permission");
    setPermissions({
      financier_stats,
      monthwise_deal_interst,
      deal_assigned_to_FI_users,
      deal_status
    });
  };

  const mergedData = finStatsData?.map((item, index) => {
    return {
      id: index,
      displayName: item.displayName,
      value: item.value,
      color: adminNumberData[index]?.color,
    };
  });

  return (
    <div>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4
                  style={{ marginLeft: "1.2rem" }}
                  className="mb-sm-0 font-size-18"
                >
                  Dashboard
                </h4>
                <div style={{ display: "flex", alignItems: "center" }}  className="mb-2">
                  <Link to="/financier/widgetSetting">
                    <FaCog
                      size={20}
                      className="smooth-icon"
                      style={{ color: "#34c38f", transition: "all 0.3s ease" }}
                    />
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
          <div className="vertical-scroll">
            {!!permissions.financier_stats && (
              <Row className="custom-row" style={{ marginBottom: "1rem" }}>
                {mergedData
                  ?.filter((item) => (user.EntityAssignedFlag ? true : !["Assigned Deals", "Unassigned Deals", "Assigned To Me"].includes(item.displayName)))
                  .map((i) => (
                    <Col style={{ marginTop: "-1rem" }} key={i.id} lg={3}>
                      {role ? (
                        <StatsCard
                          color={i.color}
                          label={i?.displayName}
                          value={i?.value}
                          url={generateStatsCardUrl(i, user)}
                        />
                      ) : (
                        <Skeleton count={5} />
                      )}
                    </Col>
                  ))}
              </Row>


            )}
            <Row style={{ marginBottom: "1rem" }}>
              {!!permissions.monthwise_deal_interst && (
                <Col lg={6}>
                  {role ? (
                    <DealsCreated userType={role} />
                  ) : (
                    <>
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                    </>
                  )}
                </Col>
              )}
              {!!permissions.monthwise_deal_interst && (
                <Col lg={6}>
                  {role ? (
                    <MonthlyDealsCreated userType={role} />
                  ) : (
                    <>
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                    </>
                  )}
                </Col>
              )}
              {!!permissions.deal_status && (
                <Col lg={6}>
                  {role ? (
                    <DealStatusFin
                      userType={role}
                      dataColors='["--bs-success", "--bs-danger", "--bs-warning", "#556ee6", "#ffa500"]'
                    />
                  ) : (
                    <>
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                    </>
                  )}
                </Col>
              )}
              {!!permissions.deal_assigned_to_FI_users && (
                <Col lg={6}>
                  <>
                    {role ? (
                      <FinAssigned userType={role} />
                    ) : (
                      <Skeleton
                        style={{ marginBottom: "1rem" }}
                        height={40}
                        count={3}
                      />
                    )}
                  </>
                </Col>
              )}
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

const adminNumberData = [
  {
    id: 1,
    label: "Total No of Deals",
    value: 55,
    color: "info",
  },
  {
    id: 2,
    label: "Assigned",
    value: 125,
    color: "success",
  },
  {
    id: 3,
    label: "UnAssigned",
    value: 33,
    color: "warning",
  },
  {
    id: 4,
    label: "Interst Shown",
    value: 300,
    color: "success",
  },
  {
    id: 5,
    label: "Assigned to me",
    value: 300,
    color: "danger",
  },
  {
    id: 6,
    label: "Deals of month",
    value: 300,
    color: "info",
  },
  {
    id: 7,
    label: "Accepted Deals",
    value: 300,
    color: "success",
  },
  {
    id: 8,
    label: "Rejected Deals",
    value: 300,
    color: "danger",
  },
];

export default FinancersDashboard;

const generateStatsCardUrl = (item, user) => {
  if (item.displayName == 'Accepted Deals') {
    return `/${user.roleName}/deals?activeTab=${6}`;
  } else if (item.displayName == 'Rejected Deals') {
    return `/${user.roleName}/deals?activeTab=${7}`;
  }
  if (item.id !== 0 && user.roleName === "financier_operations" && item.displayName !== 'Deals of Month') {
    return `/${user.roleName}/deals?activeTab=${item.id + 2}`;
  } else if (item.displayName !== 'Deals of Month') {
    return `/${user.roleName}/deals?activeTab=${item.id + 1}`;
  }
  return null;
};
